export default __webpack_public_path__ + "static/media/Sensors.f91002f3.svg";